import { IconButton } from '@ui/shared/Button';
import * as React from 'react';
import {
  ListItem,
  ListItemCell,
  ListItemSafeText,
} from '../../../shared/List/ListItem';
import { SecondaryText } from '../../../shared/SecondaryText';

interface IProps {
  shape: number[];
  teamName: string;
  role: string;
  id: string;
  onRemove: (id: string) => void;
}
export const AccessListItem = (props: IProps): React.ReactElement => {
  return (
    <ListItem>
      <ListItemCell
        style={{
          flex: props.shape[0],
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <ListItemSafeText>{props.teamName}</ListItemSafeText>
        <ListItemSafeText>
          <SecondaryText>{props.role}</SecondaryText>
        </ListItemSafeText>
      </ListItemCell>
      <ListItemCell>
        <IconButton
          icon='clear'
          title='Remove Permission'
          onClick={(): void => props.onRemove(props.id)}
        />
      </ListItemCell>
    </ListItem>
  );
};
